import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint } from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { OptsImage } from '../optsImage';
import { IItemCount } from '@educraft/base';
import { GUtil } from '../../pdf/gutil';
import { calcOrigin } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/image';
import '../../pdf/draw/transforms';

/**
 * Otoceni (Rotation) - Find the rotated image
 *
 * Layout: 5 portrait pages with increasing item counts (6, 8, 10, 12, 20).
 * Each page has opts.list.length rows. In each row, one image is randomly rotated.
 *
 * Migrated from C# EduFrame.Img10.Generators.Otoceni
 */
export class Otoceni implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 6;
  }
  countMax(): number {
    return 16;
  }

  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const { origin, size } = calcOrigin(1, opts.list.length, margin, PdfSize.A4);
    const counts = [6, 8, 10, 12, 20];
    const {random} = opts.data;

    for (const count of counts) {
      const page = pdf.addPage();

      const sz = Math.min((size.width - 10) / count, size.height * 0.9);
      const origin1x = (PdfSize.A4.width - count * sz) / 2;
      const origin1y = (size.height - sz) / 2;

      for (let i = 0; i < opts.list.length; i++) {
        const rect = new PdfRect(origin.x, origin.y + i * size.height, size.width, size.height);

        const rnd = random.next(0, count);

        for (let j = 0; j < count; j++) {
          const r = new PdfRect(origin1x + j * sz, rect.y + origin1y, sz, sz);

          if (j === rnd) {
            const center = new PdfPoint(r.centerX, r.centerY);
            const angle = random.next(0, 3) * 90 + 90;
            page.save();
            page.rotateAtTransform(angle, center);
            page.drawImageCenter(opts.list[i].image, r);
            page.restore();
          } else {
            page.drawImageCenter(opts.list[i].image, r);
          }
        }

        page.drawRectangle(GUtil.basePen, null, rect);
      }
    }
  }
}
